import { getCurrentUser } from '@creditsights/api-ui-web';
import classNames from 'classnames/bind';
import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { LockedContent } from '../../../components/LockedContent';
import { useDocumentTitle } from '../../../hooks/common';
import useFetchUserPermissions from '../../../hooks/permissions/useFetchUserPermissions';
import { hasPermissionToFinancials, hasPermissionToFinancialsExcelDownload } from '../../../utils/permissionsUtils';
import { CompanyOutletContext } from '../Company';

import styles from './CompanyFinancialsTab.module.scss';

const cx = classNames.bind(styles);

const CompanyFinancialsTab = (): React.ReactElement | null => {
  const { issuerId } = useParams();
  const { data: userPermissions } = useFetchUserPermissions();
  const hasExcelDownload = hasPermissionToFinancialsExcelDownload(userPermissions);
  const hasPermission = hasPermissionToFinancials(userPermissions);
  const { userId } = getCurrentUser();
  const { company } = useOutletContext<CompanyOutletContext>();
  useDocumentTitle(`${company.displayName}: Financials`);

  const renderIframe = () => {
    return (
      <iframe
        title="company-financials"
        className={cx('frame')}
        src={`/financials/company/${issuerId}/client_timeseries?filter=Annual&ExcelDownload=${hasExcelDownload}&section=FactStream&table=1&userid=${userId}`}
        data-testid="company-financials-as-ui"
      />
    );
  };

  const renderNoPermission = () => {
    return (
      <div className={cx('no-permission')} data-testid="company-financials-tab-no-permission">
        <div className={cx('locked-content')}>
          <LockedContent />
        </div>
      </div>
    );
  };

  if (!issuerId) {
    return null;
  }
  return (
    <div className={cx('body')} data-testid="company-financials-tab">
      {hasPermission ? renderIframe() : renderNoPermission()}
    </div>
  );
};

export default CompanyFinancialsTab;
